module.exports = __webpack_public_path__ + "img/kuwait.fb699f80.svg";